import Cookies from 'js-cookie';
class StoreTimeZone {
    run = () => {
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        Cookies.set('xmx_timezone', timezone, { sameSite: 'None', secure: true });
    }
}

export default StoreTimeZone;